<template>
  <div>
      <div v-if="errorStr">
        Sorry, but the following error
        occurred: {{errorStr}}
      </div>
      <div v-if="gettingLocation">
        <i>Getting your location...</i>
      </div>
      <div v-if="location"><br>
        Your location data is {{ location.coords.latitude }}, {{ location.coords.longitude}}
        <br>
        <a :href="'https://www.google.co.th/maps/place/CurrentLocation/@'+location.coords.latitude+','+location.coords.longitude+',17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d13.8912449!4d100.5150586'">
        View on Map
        </a>
      </div>
  </div>
</template>
<script>
export default {
  name: 'Progress',
  beforeCreate () {
  },
  components: {
  },
  data: () => ({
    location: null,
    gettingLocation: false,
    errorStr: null
  }),
  mounted () {
    if (!('geolocation' in navigator)) {
      this.errorStr = 'Geolocation is not available.'
      return
    }
    console.log('1')

    this.gettingLocation = true
    console.log('2')
    navigator.geolocation.getCurrentPosition(pos => {
      console.log('3')
      this.gettingLocation = false
      this.location = pos
    }, err => {
      console.log('4')
      this.gettingLocation = false
      this.errorStr = err.message
    }, {timeout: 10000})
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Location.vue